module.exports = __webpack_public_path__ + "static/media/Logo_BRAND.5972f045.png";